import React from "react";
import "react-table/react-table.css";
import axios from "axios";
import "./style.css";
import { NotificationManager } from "react-notifications";
import { removeData } from "../../store/action";
import { connect } from "react-redux";
import { AdminUrls } from "../../network/config";

const register_Url = AdminUrls.AUTH.REGISTER;
const getCpdHost = AdminUrls.ADMIN.GETUSERDETAILS;
const updateExternal_Url = AdminUrls.ADMIN.UPDATEEXTERNALUSER;

class RegisterForm extends React.Component {
  constructor() {
    super();
    this.accountRegisterHandler = this.accountRegisterHandler.bind(this);
    this.getLoadCpd = this.getLoadCpd.bind(this);
    this.accountEditHandler = this.accountEditHandler.bind(this);

    this.state = {
      loadHost: [],
      dupLoadHost: [],
      registerUsername: "",
      registerFirstName: "",
      registerSurname: "",
      registerPassword: "",
      registerConfirmPassword: "",
      registerEmail: "",
      registerRole: "",
      registerEmployerDetail: "",
      editsId: "",
      bool: false,
    };
    this.controller = new AbortController();
  }

  componentDidMount() {
    let editId = this.props.match.params.workFlowId;
    if (editId) {
      this.getLoadCpd(editId);
      this.setState({
        editsId: editId,
      });
    }
  }

  accountRegisterHandler() {
    if (!this.state.registerUsername) {
      return NotificationManager.error("Username should not be Empty!");
    }
    if (!this.state.registerFirstName) {
      return NotificationManager.error("FirstName should not be Empty!");
    }
    if (!this.state.registerSurname) {
      return NotificationManager.error("Surname should not be Empty!");
    }
    if (!this.state.registerEmail) {
      return NotificationManager.error("Email should not be Empty!");
    }
    if (!this.state.registerConfirmPassword) {
      return NotificationManager.error("Confirm Password should not be Empty!");
    }
    if (!this.state.registerPassword) {
      return NotificationManager.error("Username should not be Empty!");
    }
    if (!this.state.registerRole) {
      return NotificationManager.error("Role should not be Empty!");
    }
    if (this.state.registerPassword !== this.state.registerConfirmPassword) {
      return NotificationManager.error("Confirm Password not matched!");
    } else {
      let obj = {
        UserName: this.state.registerUsername,
        FirstName: this.state.registerFirstName,
        Surname: this.state.registerSurname,
        Email: this.state.registerEmail,
        ConfirmPassword: this.state.registerConfirmPassword,
        Password: this.state.registerPassword,
        RoleName: this.state.registerRole,
        EmployerId: "",
        EmployerName: "",
        UserId: "",
      };

      axios
        .post(register_Url, obj, {
          method: "POST",
          signal: this.controller.signal,
          withCredentials: true,
          credentials: "include",
          headers: {
            Authorization:
              `${this.props.user.token_type} ` + this.props.user.access_token,
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
        })
        .then((response) => response.data)
        .then((data) => {
          this.props.history.push("/usermanagment");
        })
        .catch((error) => {
          if (error?.response?.status && error?.response?.status === 401) {
            this.props.signOut();
          }
        });
    }
  }

  getLoadCpd(editId) {
    this.setState({ mainLoading: true });

    axios
      .get(getCpdHost, {
        method: "GET",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data)
      .then((data) => {
        let dup = [...data];

        let foundData = dup?.find((x) => x.UserId === editId);

        this.setState({
          registerUsername: foundData.UserName,
          registerFirstName: foundData.FirstName,
          registerSurname: foundData.Surname,
          registerEmail: foundData.Email,
          registerRole: foundData.Role,
          bool: true,
        });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  accountEditHandler() {
    let obj = {
      UserName: this.state.registerUsername,
      FirstName: this.state.registerFirstName,
      Surname: this.state.registerSurname,
      Email: this.state.registerEmail,
      RoleName: this.state.registerRole,
      EmployerId: "",
      EmployerName: "",
      UserId: this.state.editsId,
    };

    axios
      .post(updateExternal_Url, obj, {
        method: "POST",
        signal: this.controller.signal,
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data)
      .then((data) => {
        this.props.history.push("/usermanagment");
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }
  componentWillUnmount() {
    this.controller.abort();
  }

  render() {
    return (
      <div>
        <div>
          <div className="steps">
            <section className="step">
              <div className="panel panel-primary ">
                <div className="panel-heading">
                  <span>Admin Section</span>
                </div>
                <div className="register-form-flex">
                  <div className="flex-container">
                    <div className="input-modal-register">
                      <div className="label-register">
                        <label>
                          Username<span className="modal-star">*</span>
                        </label>
                      </div>
                      <div className="input-register">
                        <input
                          onChange={(e) =>
                            /^\S*$/.test(e.target.value) &&
                            this.setState({ registerUsername: e.target.value })
                          }
                          value={this.state.registerUsername}
                          type="text"
                          placeholder="Enter Username"
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="input-modal-register">
                      <div className="label-register">
                        <label>
                          First Name<span className="modal-star">*</span>
                        </label>
                      </div>
                      <div className="input-register">
                        <input
                          onChange={(e) =>
                            this.setState({ registerFirstName: e.target.value })
                          }
                          value={this.state.registerFirstName}
                          type="text"
                          placeholder="Enter First Name"
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="input-modal-register">
                      <div className="label-register">
                        <label>
                          Surname<span className="modal-star">*</span>
                        </label>
                      </div>
                      <div className="input-register">
                        <input
                          onChange={(e) =>
                            this.setState({ registerSurname: e.target.value })
                          }
                          value={this.state.registerSurname}
                          type="text"
                          placeholder="Enter Surname"
                          className="form-control"
                        />
                      </div>
                    </div>
                    {this.state.bool === false ? (
                      <div style={{ width: "100%" }}>
                        <div className="input-modal-register">
                          <div className="label-register">
                            <label>
                              Password<span className="modal-star">*</span>
                            </label>
                          </div>
                          <div className="input-register">
                            <input
                              onChange={(e) =>
                                this.setState({
                                  registerPassword: e.target.value,
                                })
                              }
                              value={this.state.registerPassword}
                              type="password"
                              placeholder="Enter Password"
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="input-modal-register">
                          <div className="label-register">
                            <label>
                              Confirm Password
                              <span className="modal-star">*</span>
                            </label>
                          </div>
                          <div className="input-register">
                            <input
                              onChange={(e) =>
                                this.setState({
                                  registerConfirmPassword: e.target.value,
                                })
                              }
                              value={this.state.registerConfirmPassword}
                              type="password"
                              placeholder="Enter Confirm Password"
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>
                    ) : null}
                    <div className="input-modal-register">
                      <div className="label-register">
                        <label>
                          Email<span className="modal-star">*</span>
                        </label>
                      </div>
                      <div className="input-register">
                        <input
                          onChange={(e) =>
                            this.setState({ registerEmail: e.target.value })
                          }
                          value={this.state.registerEmail}
                          type="email"
                          placeholder="Enter Email"
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="input-modal-register">
                      <div className="label-register">
                        <label>
                          Role<span className="modal-star">*</span>
                        </label>
                      </div>
                      <div className="input-register">
                        <select
                          className="form-control"
                          id="sel1"
                          onChange={(e) =>
                            this.setState({ registerRole: e.target.value })
                          }
                          value={this.state.registerRole}
                        >
                          <option value="" disabled hidden></option>
                          <option value="ExternalUser">ExternalUser</option>
                        </select>
                      </div>
                    </div>

                    <div className="input-modal-register">
                      <div className="label-register">
                        <label>Employer Details</label>
                      </div>
                      <div className="input-register">
                        <input
                          onChange={(e) =>
                            this.setState({
                              registerEmployerDetail: e.target.value,
                            })
                          }
                          value={this.state.registerEmployerDetail}
                          type="Employer Detail"
                          placeholder="Enter Employer Detail"
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="input-register-button">
                      {this.state.bool === false ? (
                        <button
                          type="button"
                          onClick={this.accountRegisterHandler}
                          className="btn btn-primary"
                        >
                          Submit
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={this.accountEditHandler}
                          className="btn btn-primary"
                        >
                          Submit
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(removeData()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(RegisterForm);
